import { Injectable, Inject } from '@angular/core';
import { Location, DOCUMENT } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class FacebookPixelService {

  private loadOk:boolean = false;
  isSpotify = false;

  constructor(
    @Inject(DOCUMENT) private document: any
  ) {
      this.isSpotify = this.document.location.pathname.includes('spotify') ? true : false;
  }

  load() {
    if(this.document.location.pathname.includes('spotify')){
      if (!this.loadOk) {
        var timestamp = Number(new Date());
        (function (f: any, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
                n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            }; if (!f._fbq) f._fbq = n;
            n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js?t='+timestamp);
        // (window as any).fbq.disablePushState = true; //not recommended, but can be done
        (window as any).fbq('init', '148951497268301');
        (window as any).fbq('track', 'PageView', {url: 'https://visaoffers.poshvine.com/visa-spotify/offers/spotify'} );
        this.loadOk = true;
        console.log('Facebook pixel init run!')
      }
      else {
        (window as any).fbq('track', 'PageView', {url: 'https://visaoffers.poshvine.com/visa-spotify/offers/spotify'});
        console.log('Facebook PageView event fired!')
      }
    }

  }
  cardEntered(){
    if(this.document.location.pathname.includes('spotify')){
      (window as any).fbq('track', 'ViewContent', {
        content_name: 'VisaCardNumber',
        url: 'https://visaoffers.poshvine.com/visa-spotify/offers/spotify'
      });
    }
  }
  mobileEmailEntered(){
    if(this.document.location.pathname.includes('spotify')){
      (window as any).fbq('track', 'ViewContent', {
        content_name: 'VerifiedMobileNumberEmailID',
        url: 'https://visaoffers.poshvine.com/visa-spotify/offers/spotify'
      });
    }
  }
  claimOfferClicked(){
    if(this.document.location.pathname.includes('spotify')){
      (window as any).fbq('track', 'ViewContent', {
        content_name: 'ClaimOffer',
        url: 'https://visaoffers.poshvine.com/visa-spotify/offers/spotify'
      });
    }
  }
  redeemClicked(){
    if(this.document.location.pathname.includes('spotify')){
      (window as any).fbq('track', 'ViewContent', {
        content_name: 'RedeemNow',
        url: 'https://visaoffers.poshvine.com/visa-spotify/offers/spotify'
      });
    }
  }
}
